<template>
  <div class="order-history-item">
    <div class="order-history-item__info">
      <p>{{ order.displayOrderDate || order.orderDate }}</p>
      <oie-base-dot></oie-base-dot>
      <p class="order-history-item__link">
        {{ t('headerOrderNumber') }}: <a :href="`${clientModel.orderHistoryDetailUrl}?orderNumber=${order.orderNumber}`"> {{ order.orderNumber }}</a>
      </p>
    </div>
    <oie-my-machines-list-wrapper>
      <li v-for="(row, i) in order.orderRows" :key="`${row.articleNumber}-${i}`">
        <oie-order-history-row :order-row="row"></oie-order-history-row>
      </li>
    </oie-my-machines-list-wrapper>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
.order-history-item__info {
  @include caption;
  display: flex;
  align-items: center;
  margin-bottom: measure(eighth);

}

.order-history-item__info>*:not(:last-child) {
  margin-right: measure(eighth);
}

.order-history-item__link {
  position: relative;
}

.order-history-item__link:hover {
  text-decoration: underline
}

.order-history-item__link a {
  @include reset-link;
}

.order-history-item__link a::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}

</style>
